import { TreeNode } from '@ali-hm/angular-tree-component';

/**
 * items that don't have parents
 */
export function getRootItems(arrayOfItems: TreeNode[]): TreeNode[] {
  const rootItems = [];
  for (const item of arrayOfItems) {
    if (!parentInArray(item, arrayOfItems)) {
      rootItems.push(item);
    }
  }
  return rootItems;
}

/**
 * if the parent of the specified item is contained
 */
function parentInArray(inputItem: TreeNode, arrayOfItems: TreeNode[]): boolean {
  for (const item of arrayOfItems) {
    if (item['id'] == inputItem['parent_id']) {
      return true;
    }
  }
  return false;
}

/**
 * sort an array of json objects by a particular object field
 */
export function sortByKey(array: any[], key: any): any[] {
  return array.sort((a, b) => (a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0));
}

 /**
   * an array of all descendants of the given item in the given array
   */
 export function getDescendants(
  inputItem: TreeNode,
  arrayOfItems: TreeNode[]
): TreeNode[] {
  let descendants = [];
  for (const item of arrayOfItems) {
    if (item['parent_id'] == inputItem['id']) {
      descendants.push(item);
      const itsDescendants = getDescendants(item, arrayOfItems);
      descendants = descendants.concat(itsDescendants);
    }
  }
  return descendants;
}

/**
   * item has any children contained
   */
export function hasChildrenInArray(
  inputItem: TreeNode,
  arrayOfItems: TreeNode[]
): boolean {
  for (const item of arrayOfItems) {
    if (item['parent_id'] == inputItem['id']) {
      return true;
    }
  }
  return false;
}

export function joinWithQuotes(arr: string[], separator: string): string {
  return arr.map(item => `"${item}"`).join(separator);
}